#import "./downtimeReasonInfo.gql"

query GetDowntimeReasons {
  downtimeReasons {
    ...downtimeReasonInfo
  }
}

mutation CreateDowntimeReason($id: ID!, $reason: String!, $code: String!) {
  createDowntimeReason(id: $id, reason: $reason, code: $code) {
    downtimeReason {
      ...downtimeReasonInfo
    }
  }
}

mutation DeleteDowntimeReason($id: ID!) {
  deleteDowntimeReason(id: $id) {
    code
    reason
  }
}

mutation UpdateDowntimeReason($id: ID!, $reason: String!, $code: String!) {
  updateDowntimeReason(id: $id, reason: $reason, code: $code) {
    downtimeReason {
      ...downtimeReasonInfo
    }
  }
}
